/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { doctorprofileimg } from "../imagepath";
import { AuthContext } from "../../context/AuthContext";
import { getCurrentUser } from "../../services/authService";

const CelebSidebar = () => {
  const pathnames = window.location.pathname;
  const { user: authUser } = useContext(AuthContext);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get user data from localStorage or context
    const currentUser = getCurrentUser();
    if (currentUser) {
      setUserData(currentUser);
    } else if (authUser) {
      setUserData(authUser);
    }
    setLoading(false);
  }, [authUser]); // Re-run when user context changes

  // Function to handle image loading errors
  const handleImageError = (e) => {
    console.log("Image failed to load, using fallback image");
    e.target.src = doctorprofileimg; // Fallback to default image
  };

  const getProfilePicture = () => {
    if (userData?.profilepicture) return userData.profilepicture;
    return doctorprofileimg;
  };

  const getDisplayName = () => {
    if (userData?.fullName) return userData.fullName;
    if (userData?.firstName && userData?.lastName) return `${userData.firstName} ${userData.lastName}`;
    return "Celebrity User";
  };

  const getProfession = () => {
    if (userData?.profession) return userData.profession;
    if (userData?.favoriteentertainment?.length > 0) return userData.favoriteentertainment.join(" & ");
    return "Entertainment Professional";
  };

  const getCategories = () => {
    if (userData?.categories?.length > 0) return userData.categories;
    if (userData?.favoriteentertainment?.length > 0) return userData.favoriteentertainment;
    return ["Entertainment"];
  };

  if (loading) {
    return (
      <div className="profile-sidebar doctor-sidebar profile-sidebar-new">
        <div className="widget-profile pro-widget-content">
          <div className="profile-info-widget">
            <div className="booking-doc-img">
              <div className="skeleton-avatar"></div>
            </div>
            <div className="profile-det-info">
              <div className="skeleton-text" style={{ width: '120px', height: '20px' }}></div>
              <div className="patient-details">
                <div className="skeleton-text" style={{ width: '150px', height: '16px' }}></div>
              </div>
            </div>
          </div>
        </div>
        <div className="skeleton-content" style={{ height: '40px', margin: '15px 0' }}></div>
      </div>
    );
  }

  return (
    <>
      {/* Profile Sidebar */}
      <div className="profile-sidebar doctor-sidebar profile-sidebar-new">
        <div className="widget-profile pro-widget-content">
          <div className="profile-info-widget">
            <Link to="#" className="booking-doc-img">
              <img
                src={getProfilePicture()}
                alt="User Image"
                onError={handleImageError}
                style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover',
                  borderRadius: '50%'
                }}
              />
            </Link>
            <div className="profile-det-info">
              <h3>
                <Link to="#">{getDisplayName()}</Link>
              </h3>
              <div className="patient-details">
                <h5 className="mb-0">
                  {getProfession()}
                </h5>
              </div>
              {getCategories().slice(0, 2).map((category, index) => (
                <span key={index} className="badge doctor-role-badge">
                  <i className="fa-solid fa-circle" />
                  {category}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="dashboard-widget">
          <nav className="dashboard-menu">
            <ul>
              <li className={pathnames.includes('/dashboard') ? 'active' : ''}>
                <Link to="/dashboard">
                  <i className="isax isax-category-2 me-2"></i>
                  <span>Dashboard</span>
                </Link>
              </li>
              <li className={pathnames.includes('/celeb-account') ? 'active' : ''}>
                <Link to="/celeb-account">
                  <i className="isax isax-wallet-2 me-2"></i>
                  <span>Wallet</span>
                </Link>
              </li>
              <li className={pathnames.includes('/events') ? 'active' : ''}>
                <Link to="/events">
                  <i className="isax isax-calendar me-2"></i>
                  <span>Events</span>
                </Link>
              </li>
              <li className={pathnames.includes('/completed-orders') ? 'active' : ''}>
                <Link to="/completed-orders">
                  <i className="isax isax-wallet-2 me-2"></i>
                  <span>Finished Orders</span>
                </Link>
              </li>
              <li className={pathnames.includes('/profile') ? 'active' : ''}>
                <Link to="/profile">
                  <i className="isax isax-setting-2 me-2"></i>
                  <span>Profile Settings</span>
                </Link>
              </li>
              <li>
                <Link to="/celebrity-login">
                  <i className="isax isax-logout me-2"></i>
                  <span>Logout</span>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {/* /Profile Sidebar */}
    </>
  );
};

export default CelebSidebar;